module.exports = __webpack_public_path__ + "img/profile-henry.f57adddf.png";